// extracted by mini-css-extract-plugin
export default {"loaderWrapper":"loader_loaderWrapper__wuGgE","spinner":"loader_spinner__x-wka","spin":"loader_spin__u99fp"};